var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParallelogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6863 2.08952C5.84781 1.73073 6.2047 1.5 6.59817 1.5H17.4532C18.1789 1.5 18.663 2.24873 18.3651 2.91048L14.3137 11.9105C14.1522 12.2693 13.7953 12.5 13.4018 12.5H2.5468C1.82109 12.5 1.33704 11.7513 1.63493 11.0895L5.6863 2.08952Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallelogram);
export default __webpack_public_path__ + "static/media/parallelogram.8bdfcf07f188860b3aee9c79edffffe9.svg";
export { ForwardRef as ReactComponent };